import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';
import { AuthenticationService } from './authentication.service';
import { Injectable, NgZone } from '@angular/core'
import { IEmployee } from '../model/employee';
import { APIService } from './api.service'
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable()
export class menurolesService {
    isPageEditable: boolean = false;
    httpOptions: any = {
        headers: new HttpHeaders({
         'Content-Type':  'application/json',
         'Access-Control-Allow-Origin': '*'
        })
     }
    private menuStore = new BehaviorSubject<any>(null);
    readonly menus$ = this.menuStore.asObservable();
    sidebarScrollTop = 0;
    private sessionKey: string = null;
    private refreshTimer: any;
    private request: Subscription;
    private lastFetch = 0;
    private fetchedAt = 0;

    constructor(private _http: HttpClient, private _apiServices: APIService,
        private zone: NgZone, private auth: AuthenticationService) {
        this.auth.sessionCleared$.subscribe(() => this.clearMenus());
        this.zone.runOutsideAngular(() => {
            document.addEventListener('visibilitychange', () => {
                if (!document.hidden) { this.refreshMenus(); }
            });
            window.addEventListener('storage', event => {
                if (event.key === 'currentUser' || event.key === 'userMenuCache') {
                    this.zone.run(() => this.ensureMenus());
                }
            });
        });
    }

    private activeUser(): any {
        const user = this.auth.getActiveSession();
        return user && user.userDetail ? user : null;
    }

    private keyFor(user: any): string {
        return JSON.stringify([user.userDetail.id, user.userDetail.usertype]);
    }

    get menus(): any {
        this.ensureMenus();
        return this.menuStore.value;
    }

    ensureMenus(): void {
        const user = this.activeUser();
        if (!user) { this.clearMenus(); return; }
        const key = this.keyFor(user);
        if (key !== this.sessionKey) {
            this.clearMenus(false);
            this.sessionKey = key;
            let cached;
            try { cached = JSON.parse(localStorage.getItem('userMenuCache')); } catch (e) { }
            if (cached && cached.userId === user.userDetail.id && cached.roleId === user.userDetail.usertype
                && Array.isArray(cached.menuList) && Array.isArray(cached.menuunorder)) {
                this.fetchedAt = Number(cached.fetchedAt) || 0;
                this.applyPermissions(cached.menuunorder);
                this.menuStore.next({ menuList: cached.menuList, menuunorder: cached.menuunorder });
            } else {
                localStorage.removeItem('userMenuCache');
            }
        }
        if (!this.refreshTimer) {
            this.zone.runOutsideAngular(() => {
                this.refreshTimer = setInterval(() => this.refreshMenus(), 5 * 60 * 1000);
            });
        }
        // No cache: fetch now. Stale cache: render it, then refresh silently.
        if (!this.menuStore.value || Date.now() - this.fetchedAt > 5 * 60 * 1000) { this.refreshMenus(); }
    }

    private refreshMenus(): void {
        const user = this.activeUser();
        if (!user) { this.zone.run(() => this.clearMenus()); return; }
        if (this.keyFor(user) !== this.sessionKey) {
            this.zone.run(() => this.ensureMenus());
            return;
        }
        if (this.request && !this.request.closed || Date.now() - this.lastFetch < 60000) { return; }
        this.lastFetch = Date.now();
        const key = this.sessionKey;
        this.request = this.getRoleMenus().subscribe(data => {
            const current = this.activeUser();
            if (!current || key !== this.sessionKey || key !== this.keyFor(current)) { return; }
            const response = data.response;
            const menus = { menuList: response && response.menuList || [], menuunorder: response && response.menuunorder || [] };
            this.fetchedAt = Date.now();
            this.applyPermissions(menus.menuunorder);
            if (JSON.stringify(menus) !== JSON.stringify(this.menuStore.value)) {
                localStorage.setItem('userMenuCache', JSON.stringify({ userId: current.userDetail.id,
                    roleId: current.userDetail.usertype, menuList: menus.menuList,
                    menuunorder: menus.menuunorder, fetchedAt: this.fetchedAt }));
                this.zone.run(() => {
                    this.menuStore.next(menus);
                });
            }
        }, () => { /* Keep the last successful menu during a failed background refresh. */ });
    }

    private clearMenus(removeCache: boolean = true): void {
        if (this.refreshTimer) { clearInterval(this.refreshTimer); this.refreshTimer = null; }
        if (this.request) { this.request.unsubscribe(); this.request = null; }
        this.sessionKey = null;
        this.lastFetch = 0;
        this.sidebarScrollTop = 0;
        this.isPageEditable = false;
        localStorage.removeItem('userMenuacessbilityList');
        localStorage.removeItem('isPageEditable');
        if (removeCache) { localStorage.removeItem('userMenuCache'); }
        if (this.menuStore.value !== null) { this.menuStore.next(null); }
    }

    applyPermissions(menuunorder: any[]): boolean {
        const user = this.activeUser();
        const page = (menuunorder || []).filter(entry => entry.url == location.pathname)[0];
        this.isPageEditable = !!(user && (user.userDetail.usertype == 4 || page && page.iseditable == true));
        localStorage.setItem('userMenuacessbilityList', JSON.stringify(menuunorder || []));
        localStorage.setItem('isPageEditable', JSON.stringify(this.isPageEditable));
        return this.isPageEditable;
    }
    // Method for get employee list

    getRoleMenus(): Observable<any> {       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "roleid": loginUser.userDetail.usertype,
            "userid": loginUser.userDetail.id,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getUserMenus", body, this.httpOptions)
            .catch(this.handleError);

    }

    getRole(): Observable<any> {       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "isForAdmin": true

        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getRoles", body, this.httpOptions)
            .catch(this.handleError);

    }

    getRoleUserMenus(selectedRoleId): Observable<any> {
       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            //"roleid": loginUser.userDetail.usertype,
            "roleid": selectedRoleId,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getRoleUserMenus", body, this.httpOptions)
            .catch(this.handleError);

    }


    // Method for Assign Menu according to seleted role
    assignRoleMenus(couponForm, selectedRoleid) {
       
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        var isActive = couponForm.IsMenuAssign == true ? false : true;


        let data = { "roleid": selectedRoleid, "menuid": couponForm.menuId, "isactive": isActive, "token": loginUser.token }
        //let data = couponForm;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/assignRoleMenus", body, this.httpOptions)
            .catch(this.handleError);
    }



    getUserMenus(selectedUserId): Observable<any> {
       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {

            "userid": selectedUserId,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getUserMenusAcessbility", body, this.httpOptions)
            .catch(this.handleError);

    }

    // Method for Assign Menu according to seleted userID
    assignuserMenus(couponForm, selectedUserid) {
       
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        var isActive = couponForm.IsMenuAssign == true ? false : true;

        let data = { "userid": selectedUserid, "menuid": couponForm.menuId, "isactive": isActive, "token": loginUser.token }
        //let data = couponForm;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/assignUserMenus", body, this.httpOptions)
            .catch(this.handleError);
    }

    // Provide Editable permission

    assignEditableMenus(couponForm, selectedUserid) {
       
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');        //let data = employee;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        var isActive = couponForm.IsMenuEditable == true ? false : true;

        let data = { "userid": selectedUserid, "menuid": couponForm.menuId, "iseditable": isActive, "token": loginUser.token }
        //let data = couponForm;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/assignEditableMenus", body, this.httpOptions)
            .catch(this.handleError);
    }

    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }

    getpageAcessbility() {
        const menus = this.menus;
        return this.applyPermissions(menus ? menus.menuunorder : []);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/menuroles.service.ts